export const CATALOG_COURSES = [
  {
    course_id: 'cyn_basics',
    title: 'Foundations of Filmmaking',
    instructor: 'Abha Talesara',
    description: 'A complete beginner path into filmmaking language and process.',
    long_description:
      'The Foundations of Filmmaking is a foundational course designed for aspiring filmmakers who want to understand how cinema works before choosing a specialization. The course introduces students to the language of film, storytelling, direction, cinematography, editing, sound, production design, and the overall filmmaking workflow from pre-production to distribution. \n\n Through practical examples, film analysis, assignments, and industry-oriented learning, students will gain clarity about different departments in filmmaking, understand industry hierarchy and job roles, and discover where their interests and strengths lie within the world of cinema.',
    tagline: 'Start your craft with confidence.',
    thumbnail: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1400&q=85',
    total_duration: '8h 20m',
    is_free: false,
    single_level: true,
    package_price: 5000,
    beginner_price: 999,
    modules: [],
  },
  {
    course_id: 'cyn_direction',
    title: 'Storytelling / Feature Film Direction',
    instructor: 'Abhay Nihalani',
    description: 'Direct performances and scenes with stronger emotional impact.',
    long_description:
      'A comprehensive, industry-oriented journey through the art and craft of filmmaking - from the fundamentals of visual storytelling and scene construction to advanced directing techniques, and feature film execution across Beginner, Intermediate, and Advanced modules.',
    tagline: 'Lead the set. Shape the story.',
    thumbnail: '/direction.jpeg',
    total_duration: '11h',
    is_free: false,
    package_price: 5000,
    beginner_price: 1499,
    modules: [],
  },
  {
    course_id: 'cyn_editing',
    title: 'Feature Film Editing',
    instructor: 'Vyom Mahmunkar',
    description: 'Edit narrative films with pace, rhythm, and emotional clarity.',
    long_description:
      'An immersive editing program designed to train aspiring editors in cinematic storytelling - covering editing grammar, narrative structure, and advanced feature film post-production workflows from foundational to professional-level practice.',
    tagline: 'Find the story in the cut.',
    thumbnail: '/editing.jpeg',
    total_duration: '10h 30m',
    is_free: false,
    package_price: 5000,
    beginner_price: 1299,
    modules: [],
  },
  {
    course_id: 'cyn_screenwriting',
    title: 'Screenwriting',
    instructor: 'Coming Soon',
    description: 'Every great film begins on the page.',
    long_description:
      'The Screenwriting course is designed to help aspiring writers develop the skills and knowledge needed to write screenplays that are ready for production.',
    tagline: 'Every great film begins on the page.',
    thumbnail: '/screenwriting.jpeg',
    total_duration: '5h',
    is_free: false,
    package_price: 5000,
    beginner_price: 1499,
    modules: [],
  },
];

export const catalogById = CATALOG_COURSES.reduce((acc, course) => {
  acc[course.course_id] = course;
  return acc;
}, {});

export function formatCoursePrice(course) {
  if (course.is_free || course.beginner_price === 0) return 'Free';
  if (course.beginner_price != null) {
    return `₹${course.beginner_price.toLocaleString('en-IN')}`;
  }
  return null;
}

export function formatHomeCoursePrice(course) {
  if (course.is_free || course.beginner_price === 0) return 'Free';
  if (course.beginner_price != null) {
    return `Starts from ₹${course.beginner_price.toLocaleString('en-IN')}`;
  }
  return null;
}
